const qButtons = document.querySelectorAll('.glkdLiBn5A .quick-add .button');
qButtons.forEach(button => {
    button.addEventListener('click', (event) => {
        event.preventDefault();
    });
});

// window.addEventListener("load", (event) => {
//     addcss();
//     console.log('The page has fully loaded');
// });


// function addcss() {
//     document.querySelector("#ShopifyChat.needsclick").shadowRoot.append(Object.assign(
//     document.createElement("STYLE"), 
//         {
//             innerText : `:host {
//             }
//             .chat-app {
//                 margin: 0px !important;
//             }
//             .chat-app > button {
//                 margin-left: auto !important;
//                 margin-right: 0px !important;
//                 margin-bottom: 0px !important;
//                 width: 100% !important;
//                 height: auto !important;
//                 max-width: 56px;
//                 aspect-ratio: 1 / 1;
//                 box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//                 transition: all 0.2s;
//             }
//             .chat-app > button:hover {
//                 background-color: #d64698 !important;
//                 transform: translateY(-4px);
//             }
//             .chat-app > button svg {
//                 height: auto !important;              
//             }
//             .chat-app > .chat-app--close-button svg {
//                 width: 60% !important;                
//             }
//             .chat-app > .chat-toggle svg {
//                 width: 75% !important;                
//             }
//             `
//         })
//     )
// }
document.addEventListener('DOMContentLoaded', () => {
    console.log('The HTML DOM is fully parsed and ready!');
    // Target your elements here: document.getElementById('btn')...
});